import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import GridTable from "../../../../common/components/core/GridTable";
import {useInvoicesGridContext} from '../InvoicesGridContext';
import styles from './InvoicesGrid.module.scss';

const InvoicesGrid = () => {
  const {infiniteScroll, table} = useInvoicesGridContext();

  return (
    <div id={infiniteScroll.containerID} className={styles.scrollContainer}>
      <InfiniteScroll {...infiniteScroll.props} height={648}>
        <GridTable table={table} />
      </InfiniteScroll>
    </div>
  )
};

export default InvoicesGrid;
